"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOnboardingDone = exports.checkIsOnboarding = exports.NotificationsAPI = exports.NOTIFICATIONS_LIMIT = void 0;
const ui_env_1 = require("@dcl/ui-env");
const BaseClient_1 = require("../lib/BaseClient");
exports.NOTIFICATIONS_LIMIT = 50;
class NotificationsAPI extends BaseClient_1.BaseClient {
    constructor(config) {
        const url = (0, ui_env_1.getEnv)() === ui_env_1.Env.DEVELOPMENT ? "https://notifications.decentraland.zone" : "https://notifications.decentraland.org";
        super(url, config);
    }
    getNotifications(limit = exports.NOTIFICATIONS_LIMIT, from) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams();
            if (limit) {
                params.append("limit", `${limit}`);
            }
            if (from) {
                params.append("from", `${from}`);
            }
            const { notifications } = yield this
                .fetch(`/notifications${params.toString().length ? `?${params.toString()}` : ''}`);
            return notifications.map(parseNotification);
        });
    }
    markNotificationsAsRead(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetch('/notifications/read', {
                method: "PUT",
                body: JSON.stringify({ notificationIds: ids }),
                metadata: { notificationIds: ids },
                headers: { "Content-Type": "application/json" }
            });
        });
    }
}
exports.NotificationsAPI = NotificationsAPI;
const ONBOARDING_KEY = "dcl_notifications_onboarding";
const checkIsOnboarding = () => {
    const isOnboarding = localStorage.getItem(ONBOARDING_KEY);
    if (isOnboarding) {
        const value = JSON.parse(isOnboarding);
        return value;
    }
    else {
        localStorage.setItem(ONBOARDING_KEY, "true");
        return true;
    }
};
exports.checkIsOnboarding = checkIsOnboarding;
const setOnboardingDone = () => {
    localStorage.setItem(ONBOARDING_KEY, "false");
};
exports.setOnboardingDone = setOnboardingDone;
const parseNotification = (notification) => {
    return (Object.assign(Object.assign({}, notification), { timestamp: Number(notification.timestamp) }));
};
//# sourceMappingURL=notifications.js.map